import ApiClient from '@/api/ApiClient';

const client = new ApiClient('userfavorite');

class UserFavoriteApi {

	static list () {
		return client.get<IUserFavoriteModel[] | undefined>('');
	}

	static add (addUserFavoriteModel: IAddUserFavoriteModel) {
		return client.post<IUserFavoriteModel>('', addUserFavoriteModel);
	}

	static delete (id: number) {
		return client.delete<IUserFavoriteModel[]>(id.toString());
	}

}

export default UserFavoriteApi;
